// src/services/financeiro/RecebimentoService.js
import { deleteData, fetchBlobData, fetchData, postData, putData } from '../Api';

export const buscarTodosRecebimentos = async () => fetchData('/Recebimento');

export const buscarRecebimentos = async (filtros) =>
    postData('/Recebimento/BuscaRecebimentos', filtros);

export const buscarNotasRecebimento = async (recebimentoId) =>
    fetchData(`/Recebimento/${recebimentoId}/Notas`);

export const buscarDetalhesRecebimento = async (recebimentoId) =>
    fetchData(`/Recebimento/${recebimentoId}/Detalhes`);

export const registrarPagamentoRecebimento = async (pagamento) =>
    postData('/Recebimento/Pagamentos', pagamento);

export const excluirPagamentoRecebimento = async (pagamentoId, justificativa) =>
    deleteData(`/Recebimento/Pagamentos/${pagamentoId}`, {}, { justificativa });

export const buscarComprovanteRecebimento = async (parcelaIds, paperWidthMm = 75) => {
    const parametros = new URLSearchParams();
    parcelaIds.forEach((id) => parametros.append('parcelaIds', id));
    parametros.append('paperWidthMm', paperWidthMm);
    return fetchBlobData(`/Recebimento/Comprovante?${parametros.toString()}`);
};

export const adicionarRecebimento = async (recebimento) =>
    postData('/Recebimento/Manual', recebimento);

export const alterarRecebimento = async (recebimento) =>
    putData('/Recebimento', recebimento);

export const excluirRecebimento = async (id, justificativa) =>
    deleteData('/Recebimento', { recebimentoId: id }, { justificativa });

export const excluirParcelaRecebimento = async (id, justificativa) =>
    deleteData(`/Recebimento/Parcela/${id}`, {}, { justificativa });
